export default "__VITE_ASSET__CPDwnKzH__"